import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const AlertIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M8 2.2002C11.703 2.2002 14.7 5.18087 14.7002 8.84961C14.7002 12.5185 11.7032 15.5 8 15.5C4.28921 15.5 1.2998 12.5189 1.2998 8.84961C1.30004 5.18087 4.297 2.2002 8 2.2002ZM8 2.78906C4.6313 2.78906 1.90063 5.49591 1.90039 8.84961C1.90039 12.2035 4.63115 14.9111 8 14.9111C11.3688 14.9111 14.0996 12.2035 14.0996 8.84961C14.0994 5.49591 11.3687 2.78906 8 2.78906ZM10.9131 6.97461L6.82324 11.0361L4.98926 9.21484L5.12695 9.07812L6.47949 10.4199L6.83301 10.7705L7.18457 10.4199L10.7764 6.83789L10.9131 6.97461ZM15.292 3.12695L14.9072 3.58008L11.9951 1.15332L12.3799 0.700195L15.292 3.12695ZM3.99707 1.15234L1.0918 3.57227L0.707031 3.12012L3.61719 0.702148L3.99707 1.15234Z" fill={color} stroke={color} />
  </Svg>
);

AlertIcon.displayName = 'AlertIcon';
